<template>
  <section class="messagesync">
    <title-bg></title-bg>
    <h3 class="messagesync-title">同步消息提醒</h3>
    <div class="messagesync-switch">
      <a-radio-group v-model="switchRadio">
        <a-radio :value="1">打开</a-radio>
        <a-radio :value="2">关闭</a-radio>
      </a-radio-group>
    </div>
    <a-button type="primary">确定</a-button>
  </section>
</template>
<script>
import TitleBg from '../../components/TitileBg'
export default {
  components: {
    TitleBg
  },
  data () {
    return {
      switchRadio: 1
    }
  }
}
</script>
<style lang="less" scoped>
.messagesync{
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  &-title{
    margin: 42px 0 26px;
    font-size:20px;
    font-weight:400;
    color:rgba(193,102,19,1);
  }
  &-switch{
    display: flex;
    align-items: center;
    padding-left: 26px;
    width: 100%;
    height:59px;
    background:rgba(243,243,243,1);
    border-radius:9px;
    box-sizing: border-box;
  }
  & /deep/ .ant-btn{
    margin-top: 68px;
    width:328px;
    height:60px;
    font-size:20px;
    font-weight:400;
    color:rgba(255,255,255,1);
    background:rgba(193,102,19,1);
    border-radius:9px;
  }
}
</style>
